import type { FaireProductEntity } from "../../entity_types/product";

export const p_javetey6r3: FaireProductEntity = {
  token: "p_javetey6r3",
  type: "product",
  name: "Matches • Art •Mucha Zodiac•Home Decor for Candles & Incense",
  brandToken: "b_6zicjtg87q",
  brandName: "Most Amazing",
  imageUrl:
    "https://cdn.faire.com/fastly/60059951802b9259c56462f8d52ee744a7816e0f241ac77ae55825178cd9276e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2cb19e68d0df864c23f6bfcd99b54c49d798f7dfc761324159063b9546a1f539.jpeg",
    "https://cdn.faire.com/fastly/0d36dfc98ab3b661f9f6ab8e1e3d8e1f1a94ea609bd2c422eaa4a2fd2bedddb8.jpeg",
  ],
  priceDollars: 1.66,
  description:
    "• Matches to elevate your home decor. Light your candles and incense with style.\n• These unique matchboxes feature the Zodiac, the Art of Alphonse Mucha on both sides\n• Each box contains 20-23 matches and measures about  2.25”x1.5”x.5”\n\n• NOW AVAILABLE! - CUSTOMIZE a Matchbox with YOUR SHOP LOGO! https://www.faire.com/product/p_zdp5asfpuq",
  tags: [],
  msrpDollars: 3.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:02:09.124Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
